<table class="order-table w-full text-10 desktop:text-sm border border-neutral-200">
  <tbody>
    <tr class="thead bg-primary text-white font-medium desktop:h-12">
      <th class="text-left py-1 px-1 desktop:py-0 desktop:pl-7 desktop:pr-0">QTY</th>
      <th class="text-left py-1 px-1 desktop:py-0 desktop:px-0">ORDER ID</th>
      <th class="text-left py-1 px-1 desktop:py-0 desktop:px-0">DESCRIPTION</th>
      <th class="text-left py-1 px-1 desktop:py-0 desktop:pl-7 desktop:pr-0">PRICE</th>
    </tr>
    @for (item of order.orderItems; track $index) {
      <tr class="desktop:h-12">
        <td class="py-1 px-1 desktop:py-0 desktop:pl-7 desktop:pr-0">{{ item.quantity }}</td>
        <td class="py-1 px-1 desktop:py-0 desktop:px-0">{{ order.name }}</td>
        <td class="py-1 px-1 desktop:py-0 desktop:px-0">{{ item.productName }}</td>
        <td class="py-1 px-1 desktop:py-0 desktop:pl-7 desktop:pr-0">{{ item.productPrice | currency: "USD":"symbol-narrow":".2-2" }}</td>
      </tr>
    }
    <!-- Upsell information -->
    @if (orderReceipt.upsells && orderReceipt.upsells.length) {
      @for (upsell of orderReceipt.upsells; track upsell.name) {
        @for (orderItem of upsell.orderItems; track $index) {
          <tr class="desktop:h-12">
            <td class="py-1 px-1 desktop:py-0 desktop:pl-7 desktop:pr-0">{{ orderItem.quantity }}</td>
            <td class="py-1 px-1 desktop:py-0 desktop:px-0">{{ upsell.name }}</td>
            <td class="py-1 px-1 desktop:py-0 desktop:px-0">{{ orderItem.productName }}</td>
            <td class="py-1 px-1 desktop:py-0 desktop:pl-7 desktop:pr-0">{{ orderItem.productPrice | currency: "USD":"symbol-narrow":".2-2" }}</td>
          </tr>
        }
      }
    }
    <!-- End of upsell information -->
    <!-- Summary rows share the PRICE column so the amounts line up with the item prices -->
    <tr class="summary-row tax desktop:h-8">
      <td class="text-right pt-3 pb-1 px-1 desktop:pt-5 desktop:pb-0 desktop:px-0" colspan="3">Tax:</td>
      <td class="pt-3 pb-1 px-1 desktop:pt-5 desktop:pb-0 desktop:pl-7 desktop:pr-0">{{ order.tax + upsellsTotalTax | currency: "USD":"symbol-narrow":".2-2" }}</td>
    </tr>
    <tr class="summary-row shipping desktop:h-8">
      <td class="text-right py-1 px-1 desktop:py-0 desktop:px-0" colspan="3">Shipping:</td>
      <td class="py-1 px-1 desktop:py-0 desktop:pl-7 desktop:pr-0">{{ order.orderShippingCost + upsellsShippingCost | currency: "USD":"symbol-narrow":".2-2" }}</td>
    </tr>
    <tr class="summary-row total font-bold desktop:h-8">
      <td class="text-right py-1 px-1 desktop:py-0 desktop:px-0" colspan="3">TOTAL:</td>
      <td class="py-1 px-1 desktop:py-0 desktop:pl-7 desktop:pr-0">{{ order.total + upsellsTotal | currency: "USD":"symbol-narrow":".2-2" }}</td>
    </tr>
  </tbody>
</table>
